import { render, staticRenderFns } from "./extractDialog.vue?vue&type=template&id=2353c2f0"
import script from "./extractDialog.vue?vue&type=script&lang=js"
export * from "./extractDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports